<loading [visible]="loading || saving"></loading>

<app-custom-modal [customTitle]="isNew ? 'Nuevo cierre de caja' : 'Cierre de caja'" maxWidth="3xl" [hideFooter]="!isNew"
    (closeFunction)="closeFormFunction()" (acceptFunction)="saveEntity()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-5">

        @if(isNew && offices.length > 1){
        <custom-select label="Oficina" [formControlItem]="saveForm.controls['office_id']" [options]="offices"
            bindValue="id" bindLabel="name" [isMultiple]="false" placeholder="Todas las oficinas">
        </custom-select>
        }

        @if(isNew){
        <div class="space-y-2">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
                    <input type="date" [value]="periodStart" (change)="onPeriodStartChange($any($event.target).value)"
                        class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
                    <input type="date" [value]="periodEnd" (change)="onPeriodEndChange($any($event.target).value)"
                        class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                </div>
            </div>
            <div class="flex flex-wrap items-center gap-x-3 text-xs text-gray-500">
                <span>Por defecto, hoy (desde el último cierre hasta ahora).</span>
                @if(periodEdited){
                <button type="button" (click)="resetPeriod()" class="text-blue-600 hover:underline">Volver a hoy</button>
                }
            </div>
            @if(periodError){
            <p class="text-sm text-red-600">{{ periodError }}</p>
            }
        </div>
        }

        @if(summary){
        <div class="text-sm text-gray-600 flex flex-wrap gap-x-4 gap-y-1">
            <span>Periodo: <b>{{ summary.period_start | date:'dd/MM/yyyy HH:mm' }}</b> → <b>{{ summary.period_end | date:'dd/MM/yyyy HH:mm' }}</b></span>
            @if(!isNew && summary.office?.name){ <span>Oficina: <b>{{ summary.office.name }}</b></span> }
            @if(!isNew && summary.user?.name){ <span>Usuario: <b>{{ summary.user.name }}</b></span> }
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="rounded-lg border border-gray-200 p-3">
                <p class="text-xs text-gray-500">Tickets</p>
                <p class="text-lg font-bold text-gray-900">{{ summary.tickets_count }}</p>
            </div>
            <div class="rounded-lg border border-gray-200 p-3">
                <p class="text-xs text-gray-500">Efectivo</p>
                <p class="text-lg font-bold text-gray-900" [centToEurDisplay]="summary.cash_sales"></p>
            </div>
            <div class="rounded-lg border border-gray-200 p-3">
                <p class="text-xs text-gray-500">Tarjeta</p>
                <p class="text-lg font-bold text-gray-900" [centToEurDisplay]="summary.card_sales"></p>
            </div>
            <div class="rounded-lg border border-gray-200 p-3">
                <p class="text-xs text-gray-500">Otros</p>
                <p class="text-lg font-bold text-gray-900" [centToEurDisplay]="summary.other_sales"></p>
            </div>
        </div>
        <p class="text-sm text-gray-700">Total ventas: <b [centToEurDisplay]="summary.total_sales"></b></p>
        }

        @if(isNew){
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <custom-input decimal label="Fondo inicial (€)" [formControlItem]="saveForm.get('opening_amount')">
            </custom-input>
            <custom-input decimal [autofocus]="true" label="Efectivo contado (€)"
                [formControlItem]="saveForm.get('counted_cash')">
            </custom-input>
            <custom-input decimal label="Retirada de caja (€)" [formControlItem]="saveForm.get('cash_withdrawn')">
            </custom-input>
        </div>
        }

        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 rounded-lg bg-gray-50 p-3 text-sm">
            @if(!isNew){
            <div>Fondo inicial: <b [centToEurDisplay]="summary?.opening_amount"></b></div>
            <div>
                Efectivo contado:
                @if(countedEntered){ <b [centToEurDisplay]="summary?.counted_cash"></b> } @else { <span class="text-gray-400">sin contar</span> }
            </div>
            <div>Retirada: <b [centToEurDisplay]="summary?.cash_withdrawn"></b></div>
            }
            <div>Efectivo esperado: <b [centToEurDisplay]="expectedCash"></b></div>
            <div>
                Descuadre:
                @if(countedEntered){
                <b [class.text-green-600]="difference === 0" [class.text-red-600]="difference < 0"
                    [class.text-amber-600]="difference > 0" [centToEurDisplay]="difference"></b>
                } @else { <span class="text-gray-400">—</span> }
            </div>
            <div>Queda en caja{{ countedEntered ? '' : ' (estimado)' }}: <b [class.text-red-600]="remainingCash < 0" [centToEurDisplay]="remainingCash"></b></div>
        </div>

        @if(isNew){
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
            <textarea formControlName="notes" rows="2"
                class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
        </div>
        } @else if(summary?.notes){
        <p class="text-sm text-gray-700"><span class="font-medium">Observaciones:</span> {{ summary.notes }}</p>
        }

        @if(!isNew && summary){
        <div class="flex justify-end">
            <button type="button" (click)="print()"
                class="rounded-md bg-gray-800 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700">
                Imprimir cierre
            </button>
        </div>
        }

    </form>
</app-custom-modal>
